







































import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import ListMessages from '../UI/list-messages.vue';

@Component({
  components: { PermissionAuth, ListMessages },
})
export default class ClientUnitPendingPrescription extends BaseComponent {
  @Prop()
  public unit: any;

   @Prop({
    default: false,
  })
  public isEdit: boolean;

  private loading: boolean = false;
  private error: boolean = false;

  @Watch('unit.id')
  private onUnitChange() {
    
  }
}
